/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Method_Cod_Via_CarrierInputs */

const vi_payment_method_cod_via_carrier = /** @type {(inputs: Payment_Method_Cod_Via_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COD (nhà vận chuyển thu hộ)`)
};

/**

* @param {Payment_Method_Cod_Via_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_method_cod_via_carrier = /** @type {((inputs?: Payment_Method_Cod_Via_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Method_Cod_Via_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_method_cod_via_carrier(inputs)
});